// extracted by mini-css-extract-plugin
var _1 = "Notifications-modulenotification__dJTfF";
export { _1 as "notification" }
